import { FC } from "react";
import { useTranslation } from "react-i18next";
import type { FormulatedSSR } from "../PassengerData";

const SSRChips: FC<{ ssrs: FormulatedSSR[] }> = ({ ssrs }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-2">
      {ssrs
        .filter((ssr) => ssr.count > 0)
        .map((ssr) => (
          <span
            key={ssr.label}
            className="bg-background-primary-lighter text-font-active rounded-pill flex items-center gap-1.5 px-3 py-1 text-xs font-medium"
          >
            {ssr.icon}
            {t(ssr.chipLabel, { count: ssr.count })}
          </span>
        ))}
    </div>
  );
};

export default SSRChips;
